import { Button, Center, Checkbox, Flex, Modal, ModalBody, ModalContent, ModalHeader, ModalOverlay, Text, useMediaQuery } from "@chakra-ui/react";
import { useBoolean } from "@laxmimanogna/code-quick-components";
import { useContext } from "react";
import AppColors from "../../../constants/AppColors";
import { FONT_FAMILY } from "../../../constants/Theme";
import { AuditSheetContext } from "../../../providers/AuditSheetProvider";

const SubmitModal = (props) => {
    const auditSheetContext = useContext(AuditSheetContext)
    const { isAuditSheetLoading } = auditSheetContext
    const [isNotSmallScren] = useMediaQuery('(min-width: 410px)');
    const [isChecked, icState] = useBoolean(false)
    return (
        <>
            <Modal
                isOpen={props.isOpen}
                size={'lg'}
                onClose={props.onClose}
                isCentered
            >
                <ModalOverlay style={{ backgroundColor: AppColors.lightSkyBlue }} />
                <ModalContent
                    p={15}
                    alignItems={'center'}
                >
                    <ModalHeader>
                        <Center fontSize={'xl'}
                            color={AppColors.secondary}
                            fontFamily={FONT_FAMILY.baiJamurjee}
                            fontWeight='bold'>
                            Are you sure you’re ready to
                        </Center>
                        <Center fontSize={'xl'}
                            color={AppColors.secondary}
                            fontFamily={FONT_FAMILY.baiJamurjee}
                            fontWeight='bold'>
                            submit this audit to QA review?
                        </Center>
                    </ModalHeader>
                    <ModalBody mb={2}>
                        <Flex
                            alignItems={'center'}
                            direction={isNotSmallScren ? 'row' : 'column'}
                        >
                            <Button
                                variant="outline"
                                mr={0}
                                borderRadius={25}
                                fontWeight={500}
                                outline={'2px solid #023B93'}
                                paddingInline={'35px'}
                                backgroundColor={AppColors.white}
                                marginBottom={isNotSmallScren ? '0px' : '10px'}
                                onClick={() => {
                                    props.onClose()
                                }}
                                fontSize={'sm'}

                            >
                                No, Keep Auditing
                            </Button>
                            <Button
                                ml={isNotSmallScren ? 10 : 0}
                                borderRadius={25}
                                color={AppColors.white}
                                paddingInline={'35px'}
                                backgroundColor={AppColors.primary}
                                fontWeight='normal'
                                fontSize={'sm'}
                                disabled={!isChecked}
                                isLoading={isAuditSheetLoading}
                                onClick={() => {
                                    props.onAuditSubmit()
                                }}
                            >
                                Yes, Submit
                            </Button>
                        </Flex>
                    </ModalBody>
                    <Checkbox size='md' colorScheme={'secondary'} onChange={(e) => {
                        if (e.target.checked) {
                            icState.on()
                        } else {
                            icState.off()
                        }
                    }} checked={isChecked}>
                        <Text
                            className="m-5"
                            fontSize={'xs'}
                        >
                            By submitting this document for review, you certify that all the information is correct.
                        </Text>
                    </Checkbox>

                </ModalContent>
            </Modal>
        </>
    );
}
export default SubmitModal